<template>
  <a
    :style="getStyle(styles)"
    :class="defaultClassName"
    :href="data.url"
  >
    {{ data.data }}
  </a>
</template>

<script>
  import stylesButton from "@fremcast/section/mixins/stylesButton";
  export default {
    name: "FieldButton",
    props: {
      data: Object,
      styles: Object,
      css: Object,
      defaultClassName: String
    },
    mixins: [stylesButton]
  }
</script>
